module.exports = __webpack_public_path__ + "img/icn-spec__controller--joyConDouble.54308318.svg";